<template>
	<div>
		<a-modal v-show='!ishand' id='liaotianjilu1' width='48rem' v-model="visible" on-ok="handleOk1" v-dragModal
			@cancel="handleCancel(0)" :footer="null" :keyboard='false' :maskClosable='false'>
			<div class='mark-file'>
				<div
					style="background-color: #0c8b97;border-radius:  10px 10px 0 0;color: #fff;width: 46rem;margin: 1rem 1rem 0 1rem;text-align: center;">
					聊天記錄
				</div>
			</div>
			<div solt='title' style="position: relative;">
				<!-- <div style="position: absolute;top: 0;left: 0;background-color: red;">標題</div> -->
			</div>
			<div style="paddingBottom: 1rem;border-radius: 0 0 10px 10px;padding: 1rem 30px;background-color: #fff;
			width: 46rem;margin: 0 auto;marginBottom: 1rem;">
				<div style="padding-top: 1.5rem;">
					<a-form-model ref='form' :model="params" labelAlign='left' layout="inline" hideRequiredMark>
						<a-row type='flex' justify='space-between'>
							<div style="width: 49%;">
								<a-form-model-item label='開始日期' >
									<a-date-picker v-model='params.begindate' @change="onChange" placeholder=' ' format="YYYY/MM/DD" style='width: 15.5rem;'/>
								</a-form-model-item>
							</div>
							<div style='text-align: right;width: 49%;'>
								<!-- 	<a-form-model-item label='提交時間' prop='step_datetime'>
									<div style="text-align: left;font-size: .8rem;">
										{{form.step_datetime}}
									</div>
								</a-form-model-item> -->
								<a-form-model-item label='結束日期'>
									<a-date-picker v-model='params.enddate'  @change="onChange" placeholder=' ' format="YYYY/MM/DD" style='width: 15.5rem;'/>
								</a-form-model-item>
							</div>
						</a-row>
						<a-row type='flex' justify='space-between'>
							<div style="width: 49%;">
								<a-form-model-item label='客服姓名'>
									<a-input v-model="params.kfname"  style='width: 15.5rem;' @input="kfnamefn">
										<a-tooltip slot="suffix" >
											<img :src="require('@/image/subscr/seach.png')" alt="" style='width:.8rem;cursor:pointer;' @click='getlist'>
										</a-tooltip>
									</a-input>
									<!-- onkeyup="value=value.replace(/[^\u4e00-\u9fa5]/g,'')" -->
								</a-form-model-item>
							</div>
							<div style='text-align: right;width: 49%;'>
								<a-form-model-item label='關鍵字'>
									<a-input v-model="params.searchstr"  style='width: 15.5rem;' @input="searchstrfn">
										   <a-tooltip slot="suffix" >
												<img :src="require('@/image/subscr/seach.png')" alt="" style='width:.8rem;cursor:pointer;' @click='getlist'>
										   </a-tooltip>
									</a-input>
									<!-- onkeyup="value=value.replace(/[^a-z A-Z]/g,'')" -->
								</a-form-model-item>
							</div>
						</a-row>
					</a-form-model>
				</div>
				<div>
					<div style='height: 20rem;overflow-y: auto;margin-top: 10px;' id='myscllor'>
						<a-collapse :bordered="false" expand-icon-position="right">
							<a-collapse-panel :key="ind" v-for='(item,ind) in columnsData'>
								<div slot='header' class='div_w'>
									<div style="display: flex;justify-content: space-between;font-size: .8rem;color: #000;">
										<img :src="require('@/image/subscr/l_kehu.png')" alt="" style="margin-right: 10px;"> {{item.username}} </div>
										<div style="margin-right: 20px;font-size: .8rem;color: #666;">{{item.time}}</div>
									</div>
								<div v-for='(val,ind) in item.historylist' style='margin:0;padding: .5rem 0;'
									:style='{borderBottom:ind<item.historylist.length-1?"1px solid #ddd":""}'>
								<div style='padding-top: 8px;font-size: .8rem;color: #000;' v-if='val.type == 1'>
									<!-- type 1 客服 0 客戶 -->
									<img :src="require('@/image/subscr/l_kefu.png')" alt="" style="margin-bottom: 8px;margin-right: 10px;">{{val.kfname}}
									<div style='display: flex;justify-content: space-between;  flex-wrap: wrap-reverse;'>
									<span
										style='display: inline-block;font-size: .8rem;color: #000;max-width: 80%;' v-html='val.message'></span><span style="color: #a1a1a1;">{{val.dateval + ' '+val.time}}</span></div>
								</div>
								<div style='display: flex;justify-content: space-between;padding-bottom: 8px;' v-else>
									<span style='display: inline-block;font-size: .8rem;color: #000;max-width: 80%;'>
										<img :src="require('@/image/subscr/l_kehu.png')" alt="" style="margin-right: 20px;vertical-align: top;">
										<span v-html='val.message'></span></span><span style="color: #a1a1a1;font-size: .8rem;">{{val.dateval + ' '+val.time}}</span>
								</div>
								</div>
							</a-collapse-panel>
						</a-collapse>
					</div>
					<div class="paginationView" v-if='params.pages>1'>
						<div>第{{firstPage}}到{{secPage}}條，共{{params.total}}條記錄</div>
						<div style="margin-left:auto;">
							<a-pagination v-model="params.pageNum" @change="pageChange" :total="params.total"
								:pageSize="params.perPage" />
						</div>
						<div class="pageTzView">
							<input type="text" v-model="tzPageNum" @onkeyup="valueFn" @onafterpaste="valueFn">
							<span @click="tzEvent">跳轉</span>
						</div>
					</div>
				</div>
			</div>
			<div style="width: 100%;height: 1px;"></div>
		</a-modal>
	</div>
</template>

<script>
	import socketio from "socket.io-client";
	import App from '@/assets/app.js';

	export default {
		props: ['items'],
		components: {},
		data() {
			return {
				columnsData: [{
					historylist:[]
				}],
				text: '3366',
				activeKey: '',
				
				tzPageNum: '',
				searchstr: '',
				params: { // 任務數
					missionnum: 0,
					pageNum: 1, //當前頁數
					total: 1,
					hot_status: '',
					perPage: 4, //每頁條目數
					FQAList: [],
					FQAtypeList: [],
					begindate: '',//開始日期
					enddate: '',//結束日期
					kfname: '',//客服姓名
					searchstr: '',
				},
				isrit_div: 0,
				tablist: [],
				ishand: false,
				visible: true,
			}
		},
		computed: {
			firstPage: function() {
				let _this = this;
				let a = (_this.params.pageNum - 1) * 4;
				let b = 1;
				return _this.params.total > 0 ? Number(a) + Number(b) : 0
			},
			secPage: function() {
				let _this = this;
				let a = _this.params.pageNum * 4;
				let b = a > _this.params.total ? _this.params.total : a;
				return b
			},
		},
		mounted() {
			this.getlist()
		},
		methods: {
			searchstrfn(){
				if(!this.params.searchstr){
					this.getlist()
				}
			},
			kfnamefn(){
				if(!this.params.kfname){
					this.getlist()
				}
			},
			onChange(val) {
				this.getlist();
			},
			pageChange(page, pageSize) {
				this.params.pageNum = page;
				this.getlist();
			},
			tzEvent() {
				let _this = this;
				let maxPageNum = Math.ceil(_this.params.total / _this.params.perPage);
				if (_this.tzPageNum <= maxPageNum) {
					_this.params.pageNum = Number(_this.tzPageNum);
					_this.getlist();
				} else {
					App.oTool.warningT('請輸入有效的頁碼');
				}
			},
			valueFn() {
				this.tzPageNum = this.tzPageNum.replace(/\D/g, '')
			},
			substr(str, a, b) {
				return str.toString().substring(a, b)
			},
			tzEvent() {
				let _this = this;
				let maxPageNum = Math.ceil(_this.params.total / _this.params.perPage);
				if (_this.tzPageNum <= maxPageNum) {
					_this.params.pageNum = Number(_this.tzPageNum);
					_this.getlist();
				} else {
					App.oTool.warningT('請輸入有效的頁碼');
				}
			},
			pageChange(page, pageSize) {
				this.params.pageNum = page;
				this.getlist();
			},
			getlist() {
				this.params["roomid"] = this.items.roomid
				let obj = JSON.parse(JSON.stringify(this.params))
				obj['begindate'] = this.params.begindate ? App.oDate.secsTime3(this.params.begindate._d) : '';
				obj['enddate'] = this.params.enddate ? App.oDate.secsTime3(this.params.enddate._d) : '';
				this.$ajax({
					method: 'post',
					url: this.$api.getTalkingRecordGroupWithRoomid,
					data: obj
				}).then(res => {
					if (res.data.qmiscode == 1000) {
						this.columnsData = res.data.result
						
						this.params.pageNum = res.data.pageNum
						this.params.perPage = res.data.perPage
						this.params.pages = res.data.pages
						this.params.total = res.data.total
					}
				})
			},
			handleCancel(ev) {
				this.$emit('child', 0)
			},
			handleOk1() {}
		}
	}
</script>
<style lang="scss">
	#myscllor::-webkit-scrollbar{
	    display: none;
	 }
	/* 分頁樣式 */
	#liaotianjilu1 .paginationView {
		padding-top: 1rem;
		display: flex;
		align-items: center;
		width: 100%;
		color: #666666;
		/* height:calc(100vh - 142px); */
	}

	#liaotianjilu1 .ant-pagination-item {
		background-color: #fff;
		border-color: #bfbfbf;
		color: #999999;
		margin-right: 1rem;
	}

	#liaotianjilu1 .ant-pagination-prev {
		margin-right: 1rem;
	}

	#liaotianjilu1 .ant-pagination-item a {
		color: inherit;
	}

	#liaotianjilu1 .ant-pagination-item-active {
		background-color: #f3f3f3;
		border-color: #d8d8d8;
		color: #000;
	}

	#liaotianjilu1 .ant-pagination-prev .ant-pagination-item-link,
	#liaotianjilu1 .ant-pagination-next .ant-pagination-item-link {
		background-color: #fff;
		color: #666666;
		border: 1px solid #bfbfbf;
	}

	#liaotianjilu1 .ant-pagination-disabled a,
	#liaotianjilu1 .ant-pagination-disabled:hover a,
	#liaotianjilu1 .ant-pagination-disabled:focus a,
	#liaotianjilu1 .ant-pagination-disabled .ant-pagination-item-link,
	#liaotianjilu1 .ant-pagination-disabled:hover .ant-pagination-item-link,
	#liaotianjilu1 .ant-pagination-disabled:focus .ant-pagination-item-link {
		background-color: #d8d8d8 !important;
		color: #fff !important;
	}

	#liaotianjilu1 .pageTzView {
		display: flex;
		align-items: center;
		margin-left: 0.7rem;
	}

	#liaotianjilu1 .pageTzView input {
		width: 2.6rem;
		height: 1.67rem;
		border: 1px solid #bfbfbf;
		outline: unset;
		margin-right: 0.25rem;
		border-radius: 4px;
		text-align: center;
	}

	#liaotianjilu1 .pageTzView span {
		background-color: #d8d8d8;
		border-radius: 4px;
		height: 1.67rem;
		color: #666666;
		padding: 0 0.625rem;
		line-height: 1.67rem;
	}

	#liaotianjilu1 .ant-modal-header,
	#liaotianjilu1 .ant-modal-body {
		background-color: #e5e5e5 !important;
		padding: 1rem;
		padding-top: 0.7rem;
	}

	.mark-file {
		position: absolute;
		top: 0;
		left: 0;

		div {
			width: 6rem;
			font-size: 1rem;
			padding: .5rem 1rem;
			display: inline-block;
		}
	}

	#liaotianjilu1 {
		.ant-collapse-icon-position-right > .ant-collapse-item > .ant-collapse-header .ant-collapse-arrow{
			    right: 20px;
		}
		.div_w{
			padding: 0 10px;
			display: flex;
			justify-content: space-between;
		}
		.ant-collapse-icon-position-right>.ant-collapse-item>.ant-collapse-header {
			padding: 24px 20px 24px 10px;
			background-color: #f5f5f5;
		}

		.ant-collapse-content>.ant-collapse-content-box {
		 padding: 0px 20px 4px 20px;
		}

		.ant-collapse-borderless {
			background-color: #fff;
		}

		.ant-collapse-borderless>.ant-collapse-item {
			border: 1px solid #d8d8d8;
			margin-bottom: 30px;
		}

		.ant-table-thead>tr>th,
		.ant-table-tbody>tr>td {
			padding: 8px;
		}

		.ant-radio-wrapper {
			display: flex;
			align-items: center;
		}

		.ant-form-explain {
			display: none;
		}

		.ant-modal {
			// top: 15vh;
		}

		.ant-col-12 {
			text-align: right;
		}

		.myleft {
			text-align: left;
		}

		.ant-form-item-label {
			width: 19%;
		}

		.ant-form-item,
		.ant-form-item-control {
			width: 100%;

			.ant-calendar-picker {
				width: 100%;
			}

		}

		.ant-radio-group-default {
			width: 100%;
			margin-top: .3rem;
			display: flex;
			justify-content: space-between;
			align-items: center;

			span {
				font-size: .8rem;
			}
		}

		.ant-form-item-control-wrapper {
			// width: 70%;

			.ant-form-item-control {
				width: 100%;
			}
		}

		#lastname {
			text-align: right;

			.ant-form-item-label {
				width: 10%;
			}

			.ant-form-item-control-wrapper {
				width: 86%;
			}
		}

		.ant-form-inline .ant-form-item {
			margin-right: 0;
		}



		.ant-modal-content {
			border-radius: 10px;
		}

		.ant-form-item {
			margin-bottom: 1rem;
		}

		.ant-form-item label {
			font-size: .8rem !important;
		}

		.ant-input {
			font-size: .8rem !important;
		}

		.ant-select-selection-selected-value {
			font-size: .8rem !important;
		}

		.ant-form-item-children {
			font-size: .8rem !important;
		}

		.ant-modal-body {
			padding: 0;
			padding-top: 2.5rem;
		}

		.btn1 {
			cursor: pointer;
			width: 8rem;
			height: 2rem;
			font-size: .8rem;
			color: #fff;
			border: 0;
			border-radius: 5px;
			margin: 0 3rem;
		}

		.btnx {
			background-color: #0c8b97;
		}

		.btn2 {
			background-color: #ed4849;
		}

		.mydivs {
			max-height: 7rem;
			overflow-y: auto;
			// margin-bottom: 1rem;
			padding: 1rem;
			margin-left: 4%;
			width: 96%;
			background-color: #f5f5f5;
			margin-bottom: 1rem;

			.c {
				font-size: .8rem;
			}

			.f {
				// text-align: right;
				display: flex;
				justify-content: space-between;
			}

			.t {
				margin: .5rem 0;
				border-bottom: 1px solid #d8d8d8;
			}
		}
	}
</style>
